import {memo} from 'react';
import { Typography } from "@material-tailwind/react";

const SidebarSkeleton = () => {

    return (
        <div className="max-w-full animate-pulse">
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
            <Typography
                as="div"
                variant="paragraph"
                className="mb-4 h-4 w-full rounded-full bg-gray-300 dark:bg-gray-800"
            >
                &nbsp;
            </Typography>
        </div>
    )
}

export default memo(SidebarSkeleton);
